import React from "react";

import { PinInput } from "@/components/ui/pin-input";
import { Text } from "@/components/ui/text";
import { EmailAuthLayout } from "./EmailAuthLayout";

export function LoginOTP({ email }: { email: string | undefined }) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<string>("");

  const handleOtpSubmit = async (otp: string) => {
    setIsLoading(true);

    try {
      const response = await fetch("/api/auth/verify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: otp, type: "OTP" }),
        credentials: "include", // Important for session cookies
      });

      const data = await response.json();

      if (data.success) {
        // Success - handle different redirect scenarios
        if (data.redirectUrl) {
          // Custom redirect URL
          window.location.href = data.redirectUrl;
        } else {
          // Default redirect to dashboard
          window.location.href = "/";
        }
      } else if (data.needsProfileCompletion) {
        // Special case: user needs to complete profile first
        window.location.href = data.redirectUrl || "/complete-profile";
      } else {
        // Handle error
        setError(data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please check your connection and try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <EmailAuthLayout email={email} type="otp" error={error}>
      <Text elementType="p">
        We've sent a one-time passcode to{" "}
        {email ? <span className="font-medium">{email}</span> : "your email"}.
        Enter the passcode below to sign in.
      </Text>
      <PinInput
        maxLength={6}
        minLength={6}
        containerClassName="mt-4 flex justify-center"
        autoFocus
        disabled={isLoading}
        data-1p-ignore
        onComplete={handleOtpSubmit}
      />
    </EmailAuthLayout>
  );
}
